<div *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>

<div *ngIf="!isLoading" style="height: 100%;">

    <button mat-icon-button class="matdialog-close-btn" [mat-dialog-close]="true">
        <mat-icon class="close-icon">close</mat-icon>
    </button>

    <h1 mat-dialog-title>{{requesttype == 1 ? 'Angebotsanfrage' : 'Bestellung'}} prüfen und bestätigen</h1>
    <div matßdialogßcontent>

        <div class="content">

            <div>
                <div class="co_headline">Rechnungsadresse</div>

                <div class="co_row">
                    <div class="col-6">
                        <div id="checkout_adr"></div>
                        <!-- {{rechnungAdr}} -->
                    </div>
                </div>

                <hr>

                <div class="co_headline">Lieferadresse</div>
                <div class="co_row">
                    <div>
                        <select id="cb_selectadr" [(ngModel)]="selectedItem" (ngModelChange)="onSelectadrChange($event)">
                          <option *ngFor="let item of data" [value]="item.Id"><span *ngIf="item.Hauptkunde == null">--entspricht Rechnungsadresse--</span><span *ngIf="item.Hauptkunde !== null">{{ item.Firmenname !== null ? item.Firmenname : item.Vorname + ' ' + item.Nachname }}</span></option>
                        </select>
                      </div>
                </div>
                <div class="co_row">
                    <div class="col-6">
                        <div id="delivery_adr"></div>                        
                    </div>
                </div>
            </div>

            <hr>

            <div>
                <div class="co_headline">Versandmethode</div>
                <div id="checkout_deliveryterm" class="co_row">Standard</div>

                <hr>

                <div class="co_headline">Zahlungsbedingung</div>
                <div id="checkout_paymentterm" class="co_row"></div>
            </div>

            <div>
                <div class="checkout_footer_r">
                    <button id="btn_request" *ngIf="requesttype==1" color="accent" (click)="closeDialog('do_request')" mat-raised-button>
                        Angebot anfragen
                    </button>
                    <button id="btn_order" *ngIf="requesttype==2" color="accent" (click)="closeDialog('do_order')" mat-raised-button>
                        Bestellung aufgeben
                    </button>
                </div>
            </div>

        </div>
    </div>


</div>